import { AI_CHAT_URL } from '@/config';
import useScript from '@/hooks/useScript';

const AiChatScript = () => {
  const { error } = useScript(`${AI_CHAT_URL}/sdk/chat.js`);

  if (error) {
    // !IS_PROD && console.error('Error loading chat script');
  } else {
    // !IS_PROD && console.log('Chat script loaded successfully');
  }

  return null;
};

export default AiChatScript;
